import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { TooltipPresentationProps } from "@guestsupply/MobiusOverrides/Tooltip/Tooltip";
import { cartLineCardExpandedStyles } from "@guestsupply/Overrides/Components/CartLineCardExpanded";
import MenuClose from "@guestsupply/XDL/Icons/MenuClose";
import More from "@guestsupply/XDL/Icons/More";
import ShippingWeight from "@guestsupply/XDL/Icons/ShippingWeight";
import SuccessAlert from "@guestsupply/XDL/Icons/SuccessAlert";
import { createLinkIconStyles, mergeWithCss, tippySharedStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Edit from "@insite/mobius/Icons/Edit";
import Truck from "@insite/mobius/Icons/Truck";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const smallHeadingStyles: SmallHeadingAndTextStyles = {
    heading: {
        weight: 400,
        size: 12,
        transform: "capitalize",
        css: css`
            margin-bottom: 12px;
            display: none;
            ${xScreen("lte", "md")} {
                display: block;
            }
        `,
    },
    text: {
        weight: 700,
        lineHeight: "17px",
    },
};
cartLineCardExpandedStyles.container = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 1rem 0;
    `,
};
cartLineCardExpandedStyles.productImageGridItem = {
    width: 2,
    printWidth: 1,
    css: css`
        @media print {
            max-height: 83px;
            max-width: 83px;
            padding: 0;
        }
    `,
};
cartLineCardExpandedStyles.orderLineInfoGridItem = {
    width: 10,
    printWidth: 11,
};
cartLineCardExpandedStyles.orderLineInfoContainer = {
    gap: 15,
};
cartLineCardExpandedStyles.productDescriptionAndPartNumbersGridItem = {
    width: [12, 12, 5, 5, 5],
    printWidth: 6,
};
cartLineCardExpandedStyles.productDescriptionAndPartNumbersContainer = {
    gap: 15,
};
cartLineCardExpandedStyles.productBrand = {
    nameText: {
        color: "text.main",
    },
};
cartLineCardExpandedStyles.productBrandAndDescriptionGridItem = {
    css: css`
        flex-direction: column;
    `,
    width: 12,
};
cartLineCardExpandedStyles.configurationGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};
cartLineCardExpandedStyles.productPartNumbersGridItem = {
    width: 12,
};
cartLineCardExpandedStyles.orderLineNotesGridItem = {
    width: 12,
};
cartLineCardExpandedStyles.costCodeGridItem = { width: 12 };
cartLineCardExpandedStyles.costCodeLabelText = {
    weight: "bold",
    css: css`
        margin-right: 10px;
    `,
};
cartLineCardExpandedStyles.productPriceAndQuantityGridItem = {
    width: [12, 12, 7, 7, 7],
    printWidth: 6,
};
cartLineCardExpandedStyles.productPriceAndQuantityContainer = {
    gap: 15,
};
cartLineCardExpandedStyles.priceGridItem = {
    width: [12, 12, 5, 5, 5],
    printWidth: 5,
    css: css`
        flex-direction: column;
    `,
};
cartLineCardExpandedStyles.quantityGridItem = {
    width: [12, 12, 3, 3, 3],
};
cartLineCardExpandedStyles.extendedUnitNetPriceGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-flow: wrap;
                    `,
                ],
                "max",
            )}
    `,
};
cartLineCardExpandedStyles.extendedUnitNetPrice = {
    ...smallHeadingStyles,
};
cartLineCardExpandedStyles.subtotalWithoutVatText = {
    ...smallHeadingStyles,
};
cartLineCardExpandedStyles.vatAmount = {
    ...smallHeadingStyles,
};
cartLineCardExpandedStyles.cartLineErrorMessageGridItem = {
    width: 12,
};
cartLineCardExpandedStyles.cartLineErrorMessageText = {
    color: "danger",
};

cartLineCardExpandedStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

cartLineCardExpandedStyles.price = {
    ...cartLineSharedStyles.productPrice,
};
cartLineCardExpandedStyles.costCodeGridItem = {
    ...cartLineSharedStyles.costCodeGridItem,
};
cartLineCardExpandedStyles.costCodeLabelText = {
    ...cartLineSharedStyles.costCodeLabelText,
};
cartLineCardExpandedStyles.cartLineNotes = {
    ...cartLineSharedStyles.cartLineNotes,
};

cartLineCardExpandedStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
cartLineCardExpandedStyles.smallHeadingStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                height: 15px;
                margin-bottom: 4px;
                margin-right: 8px;
                width: auto;
                @media print {
                    display: flex;
                }
            `,
        },
        heading: {
            lineHeight: "15px",
        },
        text: {
            lineHeight: "15px",
        },
    }),
};
cartLineCardExpandedStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
    container: {
        css: css`
            margin-bottom: 4px;
            flex-grow: 0;
        `,
    },
};
cartLineCardExpandedStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};
cartLineCardExpandedStyles.notify = {
    ...cartLineSharedStyles.notify,
};
cartLineCardExpandedStyles.lineContainerStyles = {
    container: {
        css: css`
            padding-right: 0;
            grid-template-columns: 91px 3fr 1.5fr 1fr 1.5fr 36px;
            &.group-cartline {
                &:last-child {
                    border-bottom: 0;
                }
            }
        `,
    },
};
cartLineCardExpandedStyles.shippingWeightWrapper = {
    ...cartLineSharedStyles.shippingWeightWrapper,
};
cartLineCardExpandedStyles.surchargesTooltip = {
    ...(cartLineSharedStyles.surchargesTooltip as TooltipPresentationProps),
};
cartLineCardExpandedStyles.totalFreightChargesLink = {
    ...cartLineSharedStyles.totalFreightChargesLink,
};
cartLineCardExpandedStyles.headlineTypography = {
    ...cartLineSharedStyles.headlineTypography,
};

cartLineCardExpandedStyles.configurationOptionText = {
    ...cartLineSharedStyles.configurationOptionText,
};

cartLineCardExpandedStyles.promotionNameText = {
    ...cartLineSharedStyles.promotionNameText,
};
cartLineCardExpandedStyles.poContainer = {
    ...mergeWithCss(tippySharedStyles, {
        css: css`
            cursor: pointer;
            margin-right: 1px;
            ${xScreen("lte", "md")} {
                margin-left: auto;
            }
        `,
    }),
};
cartLineCardExpandedStyles.applyToAllLink = {
    ...createLinkIconStyles(SuccessAlert, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
    }),
};
cartLineCardExpandedStyles.editPurchaseOrderLink = {
    ...createLinkIconStyles(Edit, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
    }),
};
cartLineCardExpandedStyles.removeLink = {
    ...createLinkIconStyles(MenuClose, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
    }),
};

cartLineCardExpandedStyles.tippyContentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
cartLineCardExpandedStyles.poListWrapper = {
    css: css`
        border-top: 1px solid ${getColor("common.border")};
        display: flex;
        flex-direction: column;
    `,
};
cartLineCardExpandedStyles.poListLink = {
    css: css`
        padding: 5px 0;
        &:hover {
            background-color: ${getColor("common.ui2")};
        }
    `,
};
cartLineCardExpandedStyles.moreIconLink = {
    css: css`
        display: flex;
        &:hover {
            color: ${getColor("common.ui8")};
        }
    `,
};
cartLineCardExpandedStyles.poModalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        border-top: 1px solid ${getColor("common.border")};
        border-bottom: 1px solid ${getColor("common.border")};
        padding: 20px 0;
    `,
};
cartLineCardExpandedStyles.polineWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
    `,
};
cartLineCardExpandedStyles.removePoWrapper = {
    css: css`
        margin-top: 20px;
        display: flex;
        justify-content: end;
        gap: 12px;
    `,
};
cartLineCardExpandedStyles.buttonsWrapper = {
    css: css`
        margin-top: 20px;
        display: flex;
        justify-content: end;
        gap: 12px;
    `,
};
cartLineCardExpandedStyles.poNumberWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

cartLineCardExpandedStyles.icon = {
    src: ShippingWeight,
    width: 16,
    height: 14,
    css: css`
        &&& {
            margin: 0;
        }
    `,
};

cartLineCardExpandedStyles.tooltipStyle = {
    cssOverrides: {
        tooltipContainer: css`
            max-width: 300px;
            width: 300px;
            ${xScreen("lte", "md")} {
                max-width: 260px;
            }
        `,
        tooltipClickable: css`
            display: flex;
            margin: 0 0 0 2px;
        `,
    },
};

cartLineCardExpandedStyles.poNumber = {
    ...createHorizontalSmallHeadingAndTextStyles(),
};

cartLineCardExpandedStyles.productImageBadgesStyle = {
    container: {
        css: css`
            margin-bottom: 8px;
        `,
    },
};
cartLineCardExpandedStyles.altDcLink = {
    ...createLinkIconStyles(Truck, {
        typographyProps: {
            size: 12,
            weight: "bold",
            lineHeight: 12,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
                css: css`
                    &&&&& {
                        margin-right: 6px;
                    }
                `,
            },
            position: "left",
        },
        css: css`
            &&& {
                display: flex;
            }
            margin-top: 4px;
        `,
    }),
};
